import React, { lazy, Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import { OperatorDodajForm, OperatorEdytujForm } from './login/OperatorForm'
import { PasswordResetForm, PasswordResetForm2 } from './login/PasswordResetForm'
import Axios from 'axios';
import _ from '../misc/i18n';
import ErrorBoundary from './misc/errorBoundary'

const OperatorzyLista = lazy(() => import('./login/OperatorzyLista'))
const OperatorzyListaWszyscy = lazy(() => import('./login/OperatorzyListaWszyscy'))
// MasterCAL
const MasterCAL = lazy(() => import('./konkursy/masterCAL/MasterCAL'))
const MasterCALCreateFakeUser = lazy(() => import('./konkursy/masterCAL/fakeUser'))
const MasterCALUserList = lazy(() => import('./konkursy/masterCAL/userList'))
const MasterCALRegisterForm = lazy(() => import('./konkursy/masterCAL/MasterCALRegisterForm'))
const Ranking = lazy(() => import('./konkursy/masterCAL/ranking'))
const MasterCALZamowienia = lazy(() => import('./konkursy/masterCAL/zamowienia'))
const EksportDoEdenRed = lazy(() => import('./konkursy/masterCAL/EksportDoEdenRed'))
// Architekt
const ArchitektRegisterForm = lazy(() => import('./archical/ArchitektRegisterForm'))
// CALkulator User Check
const CALkulatorUserCheck = lazy(() => import('./login/CALkulatorUserCheck'))
// Mailing RODO
const MailingRodoConfirm = lazy(() => import('./rodo/MailingConfirm'))
const { MailingRodoListItems } = lazy(() => import('./rodo/MailingItems'))
// Zapytanie o Wycenę drzwi
const WycenyRoutes = lazy(() => import('./zapytanieWyceny/exportRoutes'))
// reklamacje
const ReklamacjeRoutes = lazy(() => import('./reklamacje/exportRoutes'))
// Klinika Drzwi
const KlinikaDrzwiRoutes = lazy(() => import('./klinikaDrzwi/exportRoutes'))
// Gwarancja
const GwarancjaRoutes = lazy(() => import('./gwarancja/exportRoutes'))
// QandA
const QandARoutes = lazy(() => import('./qna/exportRoutes'))
// SuperUser
const AdministracjaRoutes = lazy(() => import('./administracja/exportRoutes'))
// konkurs 4x4
const Konkurs4x4Routes = lazy(() => import('./konkursy/4x4/exportRoutes'))
// CRM
const CRMRoutes = lazy(() => import('./crm/exportRoutes'))

const xml2json = lazy(() => import('../receptury/xml2json'))

const authentication = {
  session: {},
  authenticate(callback) {
    Axios('/api/login/isAuthenticated')
      .then(response => {
        this.session = response.data;
        if (this.session.loggedIn === undefined) this.session.loggedIn = false;
        callback(this.session);
      })
      .catch(error => console.log(error))
  },
  signout() {
    Axios('/api/login/signout')
      .then(response => (
        this.session = {}
      ))
      .catch(error => console.log(error))
  }
}

const AuthContext = React.createContext()

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = { session: props.session };
  }

  render() {
    const mainElement = this.state.session !== undefined ? (
      <ErrorBoundary>
        <Suspense fallback="">
          <Switch>
            <PrivateRoute exact path='/login' component={OperatorzyLista} />
            <CALAdminRoute path='/login/wszyscy' component={OperatorzyListaWszyscy} />
            <PrivateRoute path='/login/nowy' component={OperatorDodajForm} />
            <PrivateRoute path='/login/edytuj/:login_operatora' component={OperatorEdytujForm} />
            <Route exact path='/login/odzyskaj_haslo' component={PasswordResetForm} />
            <Route path='/login/odzyskaj_haslo/:hash' component={PasswordResetForm2} />
            <Route path='/login/sprawdz/' render={(props) => (
              <CALkulatorUserCheck {...props} session={this.state.session} handleShowHeaderMenu={this.props.handleShowHeaderMenu} />
            )} />

            <Route path='/rodo/mailing/:result/:imie/:email/:cel/:okres' render={(props) => (
              <MailingRodoConfirm {...props} handleShowHeaderMenu={this.props.handleShowHeaderMenu} />
            )} />
            <Route exact path='/rodo/mailing/:result/:imie/:email' render={(props) => (
              <MailingRodoConfirm {...props} handleShowHeaderMenu={this.props.handleShowHeaderMenu} />
            )} />
            <CALRoute path='/rodo/mailing/lista' component={MailingRodoListItems} />            {/* konkursy */}
            <OperatorRoute path='/konkursy/masterCAL/nowy' component={MasterCALRegisterForm} />
            <OperatorRoute exact path='/konkursy/masterCAL' component={MasterCAL} />
            <OperatorRoute path='/konkursy/masterCAL/ranking/:edycja' component={Ranking} />
            <OperatorRoute path='/konkursy/masterCAL/ranking' component={Ranking} />
            <OperatorRoute path='/konkursy/masterCAL/twojeZamowienia' component={MasterCALZamowienia} />
            <MasterCALAdminRoute path='/konkursy/masterCAL/createFakeUser' component={MasterCALCreateFakeUser} />
            <MasterCALAdminRoute path='/konkursy/masterCAL/users' component={MasterCALUserList} />
            <MasterCALAdminRoute path='/konkursy/masterCAL/eksportDoEdenRed' component={EksportDoEdenRed} />            {/* ArchiCAL - te same komponenty co MasterCAL, dostępne dla architektów */}
            <OperatorRoute exact path='/konkursy/archiCAL' component={MasterCAL} />
            <OperatorRoute path='/konkursy/archiCAL/twojeZamowienia' component={MasterCALZamowienia} />
            <MasterCALAdminRoute path='/konkursy/archiCAL/users' component={MasterCALUserList} />
            <MasterCALAdminRoute path='/konkursy/archiCAL/eksportDoEdenRed' component={EksportDoEdenRed} />
            {/* Architekt - formularz rejestracji (publiczny) */}
            <Route path='/architekt/rejestracja' component={ArchitektRegisterForm} />
            <SuperUserRoute path='/xml2json' component={xml2json} />
            {/* <SuperUserRoute path='/xmlFiles' component={XmlFiles} />
            <SuperUserRoute path='/superuser' component={SuperUser} /> */}
          </Switch>

          {/* reklamacje */}
          <ReklamacjeRoutes />
          {/* Q and A */}
          <QandARoutes />
          {/* wyceny */}
          <OperatorRoute path='/wyceny' component={WycenyRoutes} />
          {/* administracja */}
          <AdministracjaRoutes />
          {/* konkurs 4x4 */}
          <Konkurs4x4Routes />
          {/* CRM*/}
          <CRMRoutes />
          {/* Klinika Drzwi */}
          <KlinikaDrzwiRoutes />
          {/* Gwarancja */}
          <GwarancjaRoutes />
        </Suspense>
      </ErrorBoundary>
    ) : (
      <div>
        <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      </div>
    );

    return (
      <AuthContext.Provider value={authentication}>
        <div className='container-fluid'>
          {mainElement}
        </div>
      </AuthContext.Provider>
    );
  }
}

class UserMessage extends React.Component {
  render() {
    return (
      this.props.jumbotron ?
        <div className="jumbotron">
          <h1 className="display-4">{this.props.jumboTitle}</h1>
          <div className="lead text-muted">{this.props.jumboLead}</div>
          <hr className="my-4" />
          <div className="jumboContent lead">{this.props.jumboContent}</div>
        </div>
        :
        <div className={this.props.className}>{this.props.messageText}</div>
    )
  }
}

function RedirectTo(props) {
  return <div>{window.location.assign(props.redirectPath)}</div>;
}

// ścieżka jest dostępna tylko dla loginów CAL
const CALRoute = ({ component: Component, ...rest }) => {
  //console.log("authentication.session.loggedIn: ", authentication.session.loggedIn);
  return (<Route {...rest} render={
    (props) => {
      if (authentication.session.loggedIn === undefined)
        return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      return (
        authentication.session.loggedIn === false
          ? <RedirectTo redirectPath={window.location.origin} />
          : (authentication.session.loginCAL === true
            ? <Component {...props} />
            : <UserMessage className='access-denied' messageText={_('Nie masz dostępu do wyświetlania tej strony')} />
          )
      )
    }
  } />)
}

// ścieżka jest dostępna tylko dla użytkownika zalogowanego jako punkt handlowy lub administrtor
const PrivateRoute = ({ component: Component, ...rest }) => {
  //console.log("authentication.session.loggedIn: ", authentication.session.loggedIn);
  return (<Route {...rest} render={
    (props) => {
      if (authentication.session.loggedIn === undefined)
        return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      return (
        authentication.session.loggedIn === false
          ? <RedirectTo redirectPath={window.location.origin} />
          : (authentication.session.userRole === 'punkt handlowy' || authentication.session.userRole === 'administrator'
            ? <Component {...props} />
            : <div className='container'>
              <UserMessage className='access-denied' messageText={_('Nie masz dostępu do wyświetlania tej strony')} />
            </div>
          )
      )
    }
  } />)
}

const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  //console.log("authentication.session.loggedIn: ", authentication.session.loggedIn);
  return (<Route {...rest} render={
    (props) => {
      if (authentication.session.loggedIn === undefined)
        return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      if (authentication.session.loggedIn === true) return <Component {...props} />
      return <div className='container'>
        <UserMessage className='access-denied' messageText={_('Nie masz dostępu do wyświetlania tej strony')} />
      </div>
    }
  } />)
}

// ścieżka jest dostępna tylko dla użytkownika zalogowanego jako administrator z CALa
const CALAdminRoute = ({ component: Component, ...rest }) => {
  //console.log("authentication.session.loggedIn: ", authentication.session.loggedIn);
  return (<Route {...rest} render={
    (props) => {
      if (authentication.session.loggedIn === undefined)
        return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      return (
        authentication.session.loggedIn === false
          ? <RedirectTo redirectPath='htts://calkulator.drzwi-cal.pl' />
          : (authentication.session.CALAdmin === true
            ? <Component {...props} />
            : <UserMessage className='access-denied' messageText="Nie masz uprawnień do oglądania tej strony" />
          )
      )
    }
  } />)
}

// ścieżka jest dostępna tylko dla użytkownika zalogowanego jako operator lub administrator
const OperatorRoute = ({ component: Component, ...rest }) => {
  //console.log("authentication.session.loggedIn: ", authentication.session.loggedIn);
  return (<Route {...rest} render={
    (props) => {
      if (authentication.session.loggedIn === undefined)
        return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      return (
        authentication.session.loggedIn === false
          ? <RedirectTo redirectPath='htts://calkulator.drzwi-cal.pl' />
          : (authentication.session.userRole === 'operator' || authentication.session.userRole === 'administrator' || authentication.session.loginWyceny
            ? <Component {...props} />
            : <UserMessage className='access-denied' messageText={_('Strona dostępna tylko dla użytkownika zalogowanego jako operator')} />
          )
      )
    }
  } />)
}

// ścieżka jest dostępna tylko dla użytkownika zalogowanego jako operator lub administrator
const MasterCALAdminRoute = ({ component: Component, ...rest }) => {
  //console.log("authentication.session.loggedIn: ", authentication.session.loggedIn);
  return (<Route {...rest} render={
    (props) => {
      if (authentication.session.loggedIn === undefined)
        return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      return (
        authentication.session.loggedIn === false
          ? <RedirectTo redirectPath='htts://calkulator.drzwi-cal.pl' />
          : (authentication.session.masterCALAdmin === true
            ? <Component {...props} />
            : <div></div>
          )
      )
    }
  } />)
}

const CRMAdminRoute = ({ component: Component, ...rest }) => {
  // console.log("authentication.session.loggedIn: ", authentication.session.loggedIn);
  return (<Route {...rest} render={
    (props) => {
      if (authentication.session.loggedIn === undefined)
        return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      return (
        authentication.session.loggedIn === false
          ? <RedirectTo redirectPath='htts://calkulator.drzwi-cal.pl' />
          : (authentication.session.CRMAdmin === true
            ? <Component {...props} />
            : <div></div>
          )
      )
    }
  } />)
}

const SuperUserRoute = ({ component: Component, ...rest }) => {
  return (<Route {...rest} render={
    (props) => {
      if (authentication.session.loggedIn === undefined)
        return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
      return (
        authentication.session.loggedIn === false
          ? <RedirectTo redirectPath='htts://calkulator.drzwi-cal.pl' />
          : (authentication.session.SuperUser === true
            ? <Component {...props} />
            : <div></div>
          )
      )
    }
  } />)
}


const MasterCALAdminWrapper = ({ children }) => {
  return (
    authentication.session.loggedIn === true
      ? (authentication.session.masterCALAdmin === true
        ? <div>{children}</div>
        : <div></div>
      )
      : null
  )
}

const CALLoginWrapper = ({ children }) => {
  return (
    authentication.session.loggedIn === true
      ? (authentication.session.loginCAL === true
        ? <div>{children}</div>
        : <div></div>
      )
      : null
  )
}

const CRMWrapper = ({ children }) => {
  return (
    authentication.session.loggedIn === true
      ? (authentication.session.loginCAL === true || authentication.session.obslugaCRM === true
        ? <div>{children}</div>
        : null
      )
      : null
  )
}

const SuperUserWrapper = ({ children }) => {
  return (
    authentication.session.loggedIn === true
      ? (authentication.session.SuperUser === true
        ? <React.Fragment>{children}</React.Fragment>
        : null
      )
      : null
  )
}

const ReklamacjeAdminWrapper = ({ children }) => {
  return (
    authentication.session.loggedIn === true
      ? (authentication.session.ReklamacjeAdmin
        ? <React.Fragment>{children}</React.Fragment>
        : null
      )
      : null
  )
}

const KlinikaDrzwiAdminWrapper = ({ children }) => {
  return (
    authentication.session.loggedIn === true
      ? (authentication.session.KlinikaDrzwiAdmin
        ? <React.Fragment>{children}</React.Fragment>
        : null
      )
      : null
  )
}

const GwarancjaAdminWrapper = ({ children }) => {
  return (
    authentication.session.loggedIn === true
      ? (authentication.session.GwarancjaAdmin
        ? <React.Fragment>{children}</React.Fragment>
        : null
      )
      : null
  )
}

const CALAdminWrapper = (props) => {
  if (props.session.loggedIn === undefined)
    return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
  return (
    props.session.CALAdmin === true
      ? <React.Fragment>{props.children}</React.Fragment>
      : null
  )
}

const MasterCALDostepnyWrapper = (props) => {
  if (props.session.loggedIn === undefined)
    return <UserMessage className='loading-data' messageText={_('Ładowanie danych')} />
  return (
    props.session.masterCALDostepny === true
      ? <React.Fragment>{props.children}</React.Fragment>
      : null
  )
}

export {
  Main as default,
  SuperUserWrapper,
  UserMessage,
  authentication,
  RedirectTo,
  MasterCALAdminWrapper,
  MasterCALDostepnyWrapper,
  CALAdminWrapper,
  ReklamacjeAdminWrapper,
  KlinikaDrzwiAdminWrapper,
  GwarancjaAdminWrapper,
  AuthContext,
  CALLoginWrapper,
  SuperUserRoute,
  OperatorRoute,
  CALAdminRoute,
  CRMWrapper,
  CRMAdminRoute,
  AuthenticatedRoute,
}
